var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"my-4",attrs:{"align":"center","justify":"center"}},[_c('div',[_c('img',{attrs:{"src":require("@/assets/pago_distancia.png"),"alt":"Pago a distancia de Billpocket","height":"120"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }